import * as HeroIcons16 from '@heroicons/react/16/solid'
import type { ReactNode } from 'react'
type Icon = (props: React.ComponentProps<'svg'>) => ReactNode

const semanticIconsMap = {
  status: {
    error: HeroIcons16.ExclamationCircleIcon,
    warning: HeroIcons16.ExclamationTriangleIcon,
    info: HeroIcons16.InformationCircleIcon,
    success: HeroIcons16.CheckCircleIcon,
  },
} as const

export type SemanticIconNames =
  `${keyof typeof semanticIconsMap}.${keyof (typeof semanticIconsMap)[keyof typeof semanticIconsMap]}`

const splitSemanticIcon = <T extends SemanticIconNames>(key: T) =>
  key.split('.') as T extends `${infer Category}.${infer Name}`
    ? [Category, Name]
    : never

export const semanticIconMap = (key: SemanticIconNames): Icon => {
  const [category, name] = splitSemanticIcon(key)
  return semanticIconsMap[category][name]
}

export const isSemanticIcon = (name: string): name is SemanticIconNames => {
  const parts = name.split('.')
  if (parts.length !== 2) {
    return false
  }

  const [category, iconName] = parts
  return (
    category in semanticIconsMap &&
    iconName in semanticIconsMap[category as keyof typeof semanticIconsMap]
  )
}
